import { render, staticRenderFns } from "./ExperienceCollections.vue?vue&type=template&id=ba0447ac&scoped=true&"
import script from "./ExperienceCollections.vue?vue&type=script&lang=js&"
export * from "./ExperienceCollections.vue?vue&type=script&lang=js&"
import style0 from "./ExperienceCollections.vue?vue&type=style&index=0&id=ba0447ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba0447ac",
  null
  
)

export default component.exports